import { useEffect, useState } from "react";
import OrderHeader from "./Components/Header";
import QuickCartHolder from "./QuickCart/QuickCartHolder";
import PreOrderHolder from "./PreOrder/PreOrderList";
import env, { CheckAccess, defPay } from "../env";
import Cookies from "universal-cookie";
import ShowError from "../components/Modal/ShowError";
import ProductInfoHolder from "./QuickCart/ProductInfoHolder";
import { getFiltersFromUrl } from "../utils/filterUtils";
const cookies = new Cookies();
var shopVar = JSON.parse(localStorage.getItem(env.shopExpert));

function OrderHolder(props) {
  const [Pages, setPages] = useState(getFiltersFromUrl());
  const token = cookies.get(env.cookieName);
  const [grid, setGrid] = useState(shopVar ? shopVar.grid : 0);
  const [filters, setFilters] = useState();
  const [user, setUser] = useState();
  const [cart, setCart] = useState();
  const [appFilter, setAppFilter] = useState();
  const [products, setProduct] = useState();
  const [payValue, setPayValue] = useState(defPay);
  const [error, setError] = useState({ message: "", color: "brown" });
  const [tab, setTab] = useState(0);
  const [ProductInfo, setProductInfo] = useState("");
  const access = CheckAccess(token, "orders");

  useEffect(() => {
    const postOptions = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
      body: JSON.stringify({
        userId: user && user._id,
        offset: Pages.offset ? Pages.offset : "0",
        pageSize: Pages.pageSize ? Pages.pageSize : "10",
      }),
    };
    fetch(env.siteApi + "/panel/cart/get-cart", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result)
            if (result.error) {
              if (result.error === "Invalid Token Error") {
                const cookies = new Cookies();
                cookies.remove(env.cookieName, { path: "/" });
                setTimeout(() => (window.location.reload(), 1000));
              }
            } else {
              setCart(result);
            }
          else setCart("");
        },
        (error) => {
          console.log(error);
        }
      );
  }, [user, Pages]);
  useEffect(() => {
    const postOptions = {
      method: "get",
      headers: { "Content-Type": "application/json" },
    };
    fetch(env.siteApi + "/panel/faktor/list-filters", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result)
            if (result.error) {
            } else {
              setFilters(result);
            }
          else setFilters("");
        },
        (error) => {
          console.log(error);
        }
      );
  }, []);
  useEffect(() => {
    if (!appFilter) return;
    const postOptions = {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        filters: appFilter,
        stockId: token.stockId ? token.stockId : "5",
      }),
    };
    fetch(env.siteApi + "/panel/faktor/list-products", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result)
            if (result.error) {
            } else {
              setProduct(result.products);
            }
          else setProduct("");
        },
        (error) => {
          console.log(error);
        }
      );
  }, [appFilter]);

  return (
    <div className="sharif new-sharif" style={{ direction: "rtl" }}>
      <header className="sharif-order-header">
        <OrderHeader
          lang={props.lang}
          setGrid={setGrid}
          grid={grid}
          token={token}
          setError={setError}
          user={user}
          setUser={setUser}
          setFilters={setFilters}
          setProductInfo={setProductInfo}
          ProductInfo={ProductInfo}
        />
      </header>
      <main className="sharif-order-main">
        {user ? (
          <QuickCartHolder
            tab={tab}
            setTab={setTab}
            token={token}
            user={user}
            canEdit={1}
            payValue={payValue}
            setPayValue={setPayValue}
            cart={cart && cart.cart}
            pType={cart.purchaseType}
            setCart={setCart}
            setError={setError}
            cartDetail={cart && cart.cartDetail}
            bankList={cart && cart.bankList}
            totalPay={cart && cart.totalPay}
            remain={cart && cart.remain}
          />
        ) : ProductInfo ? (
          <ProductInfoHolder ProductInfo={ProductInfo} token={token} />
        ) : (
          <></>
        )}

        {user ? (
          <PreOrderHolder
            lang={props.lang}
            cart={cart}
            token={token}
            user={user}
            setCart={setCart}
            setFilters={setFilters}
            filters={filters}
            setPages={setPages}
            Pages={Pages}
          />
        ) : (
          <></>
        )}
      </main>
      {error && error.message ? (
        <ShowError
          color={error.color}
          status={"سفارشات"}
          text={error.message}
        />
      ) : (
        <></>
      )}
    </div>
  );
}
export default OrderHolder;
